





import Vue from "vue";
export const DirectionType = Object.freeze({
  column: "column",
  row: "row"
});

export default Vue.extend({
  name: "MobileSpace",
  props: {
    space: {
      type: Number,
      default: 1
    },
    direction: {
      validator(value: any) {
        return Object.keys(DirectionType).includes(value);
      },
      default: DirectionType.column
    },
    className: String
  }
});
